module.exports = __webpack_public_path__ + "img/oxymeter_black.00eb220d.svg";